import React from 'react';
import { type PropsWithChildren } from 'react';

import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuDietaryPreferencesDescription = (props: PropsWithChildren) => {
  const { children } = props;

  return <BodyText sizeMatch={['16']}>{children}</BodyText>;
};
